// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.auth-dp label.form-label[data-v-b89ca3de] {\n  color: var(--bluey-grey);\n  font-size: 0.92rem;\n}\n.login-route-link[data-v-b89ca3de] {\n  color: var(--bluey-grey);\n}\n.login-route-link[data-v-b89ca3de]:hover {\n  text-decoration: underline;\n  color: var(--sea);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
